export interface IEndpints {
	search: string
}

export interface IEvent {
	id: string
	url: string
	title: string
	description: string
	image: string
	date: string
	location: string
	categories: string[],
	dateAndTime: string,
	recurringEvent: boolean | string,
	time: number,
}

export interface IFilter {
	startDate: string
	endDate: string
	categories: string[]
}

export interface IState {
	events: IEvent[]
	count: number
	total: number
	page: number
	categories: string[]
	endpoints: IEndpints
	translations: {}
	filter: IFilter
	loading: boolean
	canLoadMore: boolean,
	showCategoryFilter: boolean
}

const deafultState: IState = {
	events: [],
	count: 0,
	total: 0,
	page: 0,
	categories: [],
	endpoints: {
		search: ''
	},
	translations: {},
	filter: {
		startDate: '',
		endDate: '',
		categories: []
	},
	loading: false,
	canLoadMore: false,
	showCategoryFilter: false
}

export default deafultState;
